import axios from "axios";
import {toast} from "react-toastify";
import ProjectUtils from "../../utils/project-utils.js";

const API_URL = import.meta.env.VITE_API_URL;

const OccurrencesDetailsService = {
    apply: async (payload) => axios.post(API_URL + "/occurrences_details/apply", payload).then(({ data }) => data).catch((err) => { throw err }),

    openSentryView: async (id) =>
        axios.get(API_URL + `/occurrence/open-sentryview/${id}`)
            .then(() => {
                toast.success(`A ocorrência ${id} será aberta no SentryView.`)
            })
            .catch((error) => {
                console.error(error);
                ProjectUtils.swalErrorMessage("", "Não foi possível abrir a ocorrência no SentryView", "Ok");
                throw error;
            }),
}

export default OccurrencesDetailsService;